<template>
<div class="chapter">
<div class="inner_page">
<h2 class="part-number"><a id="a146"></a><a id="page_1"></a>Part I</h2>
<h2 class="parttitle"><a id="ncx126"></a>ECONOMIC EFFICIENCY AND THE ROLE OF GOVERNMENT</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 11_Part_1.vue?f1a8b2f6